const emptyNodeShim = {};

export default emptyNodeShim;